module.exports = __webpack_public_path__ + "static/media/comment-alt-lock.42b2b4eb.svg";